import { t } from '@lingui/macro';
import {UserReviewItemType} from "~components/reviews/types";

export const reviewsSamples: UserReviewItemType[] = [
    {
        id: 1,
        userName: t`reference.user`,
        location: t`reference.user.flower_studio.location`,
        userComment: t`reference.user.flower_studio`,
        userImg: '🧑‍🎤',
        stars: 5
    },
    {
        id: 2,
        userName: t`reference.user`,
        location: t`reference.user.coffee.location`,
        userComment: t`reference.user.coffee`,
        userImg: '🥷🏻',
        stars: 5
    },
    {
        id: 3,
        userName: t`reference.user`,
        location: t`reference.user.bardotka_coffee.location`,
        userComment: t`reference.user.bardotka_coffee`,
        userImg: '👑',
        stars: 5
    },
];
